export const ROLES_IDS = {
  ADMIN: "1",
  STUDENT: "2",
  TRAINER: "3",
} as const;

export const ROLES_OPTIONS = [
  { value: ROLES_IDS.STUDENT, label: "Kursant" },
  { value: ROLES_IDS.ADMIN, label: "Administrator" },
  { value: ROLES_IDS.TRAINER, label: "Trener" },
];
